import Route from '@ember/routing/route'
import { task, timeout } from 'ember-concurrency'
import { Product } from 'teacher-ui-client/utils/products'
import type { Precinct } from 'teacher-ui-client/utils/precincts'
import { defaultPrecinctForProduct, isValidPrecinctForProduct, isPrecinct } from 'teacher-ui-client/utils/precincts'
import { service } from '@ember/service'
import type ContentfulClient from 'teacher-ui-client/services/contentful-client'
import type { Params } from 'teacher-ui-client/subscription-type/lessons/route'

export default class ReadingEggspressLessonsRoute extends Route {
  @service contentfulClient!: ContentfulClient

  model() {
    const lessonsParams = this.paramsFor('subscription-type.lessons') as Params
    const { perPage, pageNumber, searchQuery } = lessonsParams

    const precinct =
      isPrecinct(lessonsParams.precinct) && isValidPrecinctForProduct(Product.REX, lessonsParams.precinct)
        ? lessonsParams.precinct
        : defaultPrecinctForProduct(Product.REX)

    return {
      loaderInstance: this.fetchEntries.perform({ pageNumber, perPage, searchQuery, precinct }),
    }
  }

  fetchEntries = task(
    { restartable: true },
    async ({
      pageNumber,
      perPage,
      searchQuery,
      precinct,
    }: {
      pageNumber: number
      perPage: number
      searchQuery?: string
      precinct: Precinct
    }) => {
      await timeout(500)
      const lessonsData = await this.contentfulClient.getPrecinctLessonsData(precinct, {
        pageNumber,
        perPage,
        searchQuery,
      })
      const { previewByLessonDataId, resourcesByLessonDataId } =
        await this.contentfulClient.getLessonsDataRelatedEntries(lessonsData)

      const pageCount = Math.ceil(lessonsData.total / perPage)

      return { lessonsData, previewByLessonDataId, resourcesByLessonDataId, pageCount }
    },
  )
}
